import { render, staticRenderFns } from "./BarcodeScannerComponent.vue?vue&type=template&id=5c536d2b&"
import script from "./BarcodeScannerComponent.vue?vue&type=script&lang=js&"
export * from "./BarcodeScannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeScannerComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports